import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./cart.css";

function Cart() {
  const navigate = useNavigate(); // Initialize the navigation hook



  const [cart, setCart] = useState([]);

  useEffect(() => {
    // Retrieve cart from localStorage on component mount
    try {
      const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
      setCart(savedCart);

      if (savedCart.length === 0) {
        alert("No products in the cart");
      }
    } catch (error) {
      console.error("Error retrieving cart from localStorage:", error);
    }
  }, []);

  const handleDelete = (productId) => {
    const updatedCart = cart.filter((item) => item.id !== productId);
    setCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const handleQuantityChange = (productId, operation) => {
    const updatedCart = cart.map((item) => {
      if (item.id === productId) {
        let newQuantity = item.quantity || 1;
        if (operation === "increase") newQuantity++;
        if (operation === "decrease" && newQuantity > 1) newQuantity--;
        return { ...item, quantity: newQuantity };
      }
      return item;
    });

    setCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const getTotalPrice = () => {
    return cart.reduce((total, item) => {
      const itemPrice = item.price || 0;
      const itemQuantity = item.quantity || 1;
      return total + itemPrice * itemQuantity;
    }, 0);
  };


  const handlePayment = () => {
    const totalAmount = getTotalPrice(); // Calculate the total price
    const cartItems = cart; // This contains the list of items in the cart
  
    // Navigate to the payment page and pass the totalAmount and cartItems as state
    navigate('/payment', { state: { totalAmount, cartItems } });
  };
  



  if (cart.length === 0) {
    return (
      <div className="cart-container">
        <p>No products in the cart</p>
      </div>
    );
  }



  return (
    <div className="cart-container">
      
      {cart.map((item) => (
        <div key={item.id} className="cart-item">
          <img
            src={item.image || ""}
            alt={item.name || "Product Image"}
            className="cart-item-image"
          />
          <div className="cart-item-details">
            <h2>{item.name || "Unnamed Product"}</h2>
            <p>Rs. {(item.price || 0).toLocaleString()}</p>
            <p>
              Quantity:{" "}
              <button
                onClick={() => handleQuantityChange(item.id, "decrease")}
                disabled={(item.quantity || 1) === 1}
                aria-label="Decrease quantity"
              >
                -
              </button>
              {item.quantity || 1}
              <button
                onClick={() => handleQuantityChange(item.id, "increase")}
                aria-label="Increase quantity"
              >
                +
              </button>
            </p>
            <button
              onClick={() => handleDelete(item.id)}
              className="cart-delete-btn"
              aria-label="Delete product"
            >
              Delete
            </button>
          </div>
          <p>
            Total: Rs. {((item.price || 0) * (item.quantity || 1)).toLocaleString()}
          </p>
        </div>
      ))}

      <div className="cart-total">
        <h3>Total Price: Rs. {getTotalPrice().toLocaleString()}</h3>
      </div>

      <div className="payment-section">
        <button onClick={handlePayment} className="payment-btn">
          Proceed to Payment
        </button>
      </div>
    </div>
  );
}

export default Cart;
